module.exports = __webpack_public_path__ + "static/media/AC_off.a534533f.svg";